'use client';

import { useVoiceoverTabContext } from '../_context/VoiceoverTabContext';

export function useHasUnpersistedVoiceoverGeneration(): boolean {
    const { textToSpeech, cloneMyVoice, voiceChanger } = useVoiceoverTabContext();
    return [textToSpeech, cloneMyVoice, voiceChanger].some(
        (tab) => tab.generatedAudioIsFetching || (tab.generatedAudioUrl && !tab.generatedAudioHasDownloaded),
    );
}
